import { createIntl, createIntlCache } from "react-intl";
import messages_en from "../../languages/en-US.json";
import messages_fr from "../../languages/fr-FR.json";

const messages = {
  en: messages_en,
  fr: messages_fr,
};

const cache = createIntlCache();

const GetIntlCustom = (locale) => {
  const selectedMessages = messages[locale == "en-US" ? "en" : "fr"];
  return createIntl({ locale, messages: selectedMessages }, cache);
};

export default GetIntlCustom;
